"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var utils_1 = require("./utils");
var getVisibilityChangeProps = function () {
    if (typeof document.hidden !== 'undefined') {
        // This covers most cases
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }
    // @ts-ignore
    else if (typeof document.msHidden !== 'undefined') {
        // Internet Explorer and Microsoft Edge
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        // Older versions of webkit browsers (Chrome, Safari, newer versions of Opera, almost all iOS browsers (including Firefox for iOS))
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }
    return undefined;
};
var TrackTime = /** @class */ (function (_super) {
    __extends(TrackTime, _super);
    function TrackTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hidden: '',
            visibilityChange: '',
            totalActiveMillis: 0,
            totalAbsentMillis: 0,
            lastEventTime: Date.now(),
            // sets the user state active,
            // which requires a previous event of userInactive to kick things off.
            lastEvent: 'userInactive',
            userState: 'active',
        };
        _this.getTimeDelta = function () {
            var now = Date.now();
            return {
                now: now,
                elapsed: now - _this.state.lastEventTime,
            };
        };
        _this.onChangeUserStatus = function (statusType) {
            var _a = _this.state, totalAbsentMillis = _a.totalAbsentMillis, totalActiveMillis = _a.totalActiveMillis, userState = _a.userState;
            var _b = _this.getTimeDelta(), elapsed = _b.elapsed, now = _b.now;
            // we're switching from 'inactive' to 'active', so the event will be 'userActive'
            // and the current userState will be 'inactive'
            // since we have a few events handling a visibility change (mouseleave, mousenter, and the
            // events triggered by the visibility change api) we need to double-check that we're not already // counting active/inactive time before we change the user status.
            if (statusType === 'userActive' && userState === 'inactive') {
                _this.setState({
                    totalAbsentMillis: totalAbsentMillis + elapsed,
                    lastEvent: 'userActive',
                    lastEventTime: now,
                    userState: 'active',
                });
            }
            else if (statusType === 'userInactive' && userState === 'active') {
                _this.setState({
                    totalActiveMillis: totalActiveMillis + elapsed,
                    lastEvent: 'userInactive',
                    lastEventTime: now,
                    userState: 'inactive',
                });
            }
        };
        _this.onUserActive = lodash_1.partial(_this.onChangeUserStatus, 'userActive');
        _this.onUserInactive = lodash_1.partial(_this.onChangeUserStatus, 'userInactive');
        _this.beginEventListening = function () {
            document.addEventListener(_this.state.visibilityChange, _this.handleVisibilityChange);
            window.addEventListener('beforeunload', _this.onClosePage);
            document.addEventListener('mouseleave', _this.onUserInactive);
            document.addEventListener('mouseenter', _this.onUserActive);
            _this.onUserActive();
        };
        _this.onClosePage = function () {
            var _a = _this.state, totalActiveMillis = _a.totalActiveMillis, totalAbsentMillis = _a.totalAbsentMillis, userState = _a.userState;
            var trackingProps = _this.props.trackingProps || {};
            var elapsed = _this.getTimeDelta().elapsed;
            var message = _this.props.trackingMessage || 'track time';
            _this.props.track(message, __assign(__assign({}, trackingProps), { totalActiveTime: totalActiveMillis + (userState === 'active' ? elapsed : 0), totalAbsentTime: totalAbsentMillis + (userState === 'inactive' ? elapsed : 0) }));
            document.removeEventListener('mouseleave', _this.onUserInactive);
            window.removeEventListener('beforeunload', _this.onClosePage);
            document.removeEventListener('mouseenter', _this.onUserActive);
        };
        _this.handleVisibilityChange = function () {
            if (lodash_1.get(document, [_this.state.hidden])) {
                _this.onUserInactive();
            }
            else {
                _this.onUserActive();
            }
        };
        return _this;
    }
    TrackTime.prototype.componentWillUnmount = function () {
        if (utils_1.isBrowser()) {
            this.onClosePage();
        }
    };
    TrackTime.prototype.componentDidMount = function () {
        if (utils_1.isBrowser()) {
            var visibilityChangeProps = getVisibilityChangeProps();
            if (visibilityChangeProps) {
                this.setState(visibilityChangeProps, this.beginEventListening);
            }
        }
    };
    TrackTime.prototype.render = function () {
        return this.props.children;
    };
    return TrackTime;
}(react_1.default.Component));
exports.default = TrackTime;
